import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/flowManage',
    meta: { title: '流程管理' },
    component: Layout,
    redirect: '/flowManage/list',
    children: [
      {
        path: 'list',
        meta: { title: '流程管理', activeMenu: '/flowManage' },
        component: () => import('@/views/flowManage/FlowManage.vue')
      },
      {
        path: 'detail',
        meta: { title: '流程详情', activeMenu: '/flowManage' },
        component: () => import('@/views/flowManage/FlowManageDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑流程', activeMenu: '/flowManage' },
        component: () => import('@/views/flowManage/FlowManageAdd.vue')
      }

    ]
  }

]
